import { observable } from "mobx";
import ChargeObtainingPaymentConfirmationRejectionReason from "./chargeObtainingPaymentConfirmationRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ObtainingPaymentConfirmationPermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: ChargeObtainingPaymentConfirmationRejectionReason;
}
